import Icon from '@ui/icons'
import {FormikYesNo} from '@ui/radio/FormikYesNo'
import {FormikGooglePlacesCombobox, FormikInput} from '~/src/design-system-shims'
import React from 'react'
import type {IAgencyBase, ICompanyBase} from '~/src/models'
import styled from 'styled-components'
import {Button} from '~/src/design-system/Primitives'

const Red = styled('span')`
  color: #ff6760;
`

const CloseButton = styled(Button).attrs({variant: 'ghost' as const})`
  display: none;
  height: 28px;
  min-width: 28px;
  padding: 0;
`

const ButtonContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  position: 'absolute',
  right: -28,
  top: '50%',
  transform: 'translateY(-50%)',
  width: 28,

  [`&:hover ${CloseButton}`]: {
    display: 'flex',
  },
})
const HoverButton = styled('div')({
  [`&:hover ${CloseButton}`]: {
    display: 'flex',
  },
})

const Field = styled('div')({
  position: 'relative',
})

/** DS-layout: use Stack/Grid from ~/src/design-system for new layout code */
const FormRow = styled('div')`
  display: grid;
  grid-template-columns: 5fr 1fr 6fr;
  gap: var(--space-6);
`

interface IProps {
  activePlatform: string
  index: number
  remove: (index: number) => void
  setFieldValue: (field: string, value: unknown) => void
  addresses: string | number | boolean | null
  initialEditValues: IAgencyBase | ICompanyBase | undefined
}

export default function CompanyAddressSignInItem(props: IProps) {
  const {index, remove, setFieldValue, addresses} = props
  const testId = `company-address-index-${index}`

  return (
    <>
      <HoverButton>
        <FormRow key={index} data-testid={testId}>
          <Field>
            <div style={{paddingBottom: 'var(--space-2)'}}>
              Location Name<Red>*</Red>:
            </div>
            <FormikInput name={`addresses.${index}.name`} placeholder="Headquarters" />
          </Field>
          <div />

          <Field>
            <div style={{paddingBottom: 'var(--space-2)'}}>
              Location Address<Red>*</Red>:
            </div>
            <FormikGooglePlacesCombobox
              name={`addresses.${index}.address`}
              initialEditValues={props.initialEditValues}
              setFieldValue={setFieldValue}
              value={addresses}
              address={false}
            />
            {index !== 0 && (
              <ButtonContainer>
                <CloseButton
                  variant="ghost"
                  size="sm"
                  onClick={() => remove(index)}
                  aria-label="Remove address">
                  <Icon icon="close" />
                </CloseButton>
              </ButtonContainer>
            )}
          </Field>
        </FormRow>
        <div>
          <Field>
            <div style={{paddingBottom: 'var(--space-2)', paddingTop: 'var(--space-2)'}}>
              Onsite Facility<Red>*</Red>:
            </div>
            <div>Is this location an On-Site Facility?</div>
            <FormikYesNo name={`addresses.${index}.isOnsite`} />
          </Field>
        </div>
      </HoverButton>
    </>
  )
}
